import Axios from 'axios';
import { TrabalhoApiResponse } from '../../trabalho.types';

interface Params {
  urlBase: string;
  token: string;
  idEntrega: string;
}

export const consultarTrabalhosV21Service = async ({
  urlBase,
  token,
  idEntrega,
}: Params): Promise<TrabalhoApiResponse[]> => {
  const authorization = `Bearer ${token}`;

  const { data } = await Axios.get(`${urlBase}/v2.1/trabalhos?idEntrega=${idEntrega}`, {
    headers: { authorization },
  });

  return data;
};
